// extracted by mini-css-extract-plugin
export var container = "_mo-0";
export var dotAnimation = "_mo-2";
export var dotsLoading = "_mo-1";